
import CardRemove from "../../../assets/filled/CardRemove.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CardRemoveIcon({ className, dataTestid = "CardRemoveIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <CardRemove data-testid={dataTestid} className={classes} {...rest} />
  );
}
